<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista egresos</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <!-- customizar permisos -->
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/caja/egresos/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear egreso </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <div class="content__subhead__inputGrid">
                <div class="input-group" style="width: 105%;">
                  <span class="input-group-prepend">
                    <span class="input-group-text content__subhead__inputGrid__title">
                      <i class="far fa-calendar-alt"></i>
                    </span>
                  </span>
                  <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Cod.Caja</th>
                  <th>Fecha</th>
                  <th>N° egreso</th>
                  <th>Usuario</th>
                  <th>Caja Asig.</th>
                  <th>Receptor</th>
                  <th>Concepto</th>
                  <th class="text-center">Método pago</th>
                  <th>Monto</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr [ngClass]="{'text-danger': item.deleted_at != null }"
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <div class="bold f-s-12">{{item.moneybox_voucher}}</div>
                      <ng-container *ngIf="!item.status_moneybox.status_closed">
                        <p class="badge badge-primary f-s-8 bold m-b-0 p-t-4 p-b-3">Abierta</p>
                      </ng-container>
                      <ng-container *ngIf="item.status_moneybox.status_closed">
                        <p class="badge badge-warning f-s-8 bold m-b-0 p-t-4 p-b-3">Cerrada</p>
                      </ng-container>
                    </td>
                    <td>{{item.date_movement}}</td>
                    <td>
                      <div class="bold">
                        {{item.nro_voucher}}
                      </div>
                    </td>
                    <td>
                      <div class="f-s-12">{{item.username}}</div>
                      <ng-container *ngIf="item.verified_user">
                        <div class="badge badge-dark f-s-8 bold m-b-0 p-t-4 p-b-3">(Responsable)</div>
                      </ng-container>
                    </td>
                    <td>{{item.branchbox}}</td>
                    <td>
                      <ng-container *ngIf="item.reference_emisor_receptor != null">
                        <div>
                          <p class="m-b-0">
                            <span class="bold f-s-12">{{item.reference_emisor_receptor.description}}:
                            </span>{{item.reference_emisor_receptor_data.fullname}}</p>
                          <p class="bold f-s-10 m-b-0">N° DOC :{{item.reference_emisor_receptor_data.document}}</p>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="item.reference_emisor_receptor == null">
                        <span>-</span>
                      </ng-container>
                    </td>
                    <td>{{item.concept.description}}</td>
                    <td class="text-center">{{item.paymethod.description}}</td>
                    <td>{{item.amount}}</td>
                    <ng-container *ngIf="item.deleted_at == null">
                      <td class="text-center">
                        <ng-container *ngIf="!item.is_paycredit">
                          <div>
                            <a target="_blank" href="/{{branchofficeSlug}}/api/print/income/document/{{item.id}}">
                              <i class="far fa-file-pdf f-s-15 text-warning"></i>
                            </a>
                            <ng-container *ngIf="!item.status_moneybox.status_closed && item.verified_user">
                              <a class="pointer m-l-10" (click)="delete(item)">
                                <i class="far fa-trash-alt m-r-5 text-danger"></i>
                              </a>
                            </ng-container>
                            <!-- <div class="btn-group mo-mb-2 m-l-5">
                                <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <i class="fas fa-ellipsis-h"></i>
                                </button>
                                <div class="dropdown-menu" x-placement="bottom-start"> 
                                  <ng-container *ngIf="!item.status_moneybox.status_closed && item.verified_user">
                                    <a class="dropdown-item pointer" (click)="delete(item)">
                                      <i class="far fa-trash-alt m-r-5 text-danger"></i>Anular
                                    </a>
                                  </ng-container>
                                </div>
                              </div> -->
                          </div>
                        </ng-container>
                        <ng-container *ngIf="item.is_paycredit">
                          <div>
                            <span class="badge badge-secondary f-s-10">Pago crédito</span>
                          </div>
                        </ng-container>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="item.deleted_at != null">
                      <td>
                        <span class="badge badge-danger">Anulado</span>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
